module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Git#1-25fd44431eeb8b6f5f4bdafda3fb8a24.svg";